import React from 'react';

const Payment = () => {
    return (
        <div>
            payment method coming soon
        </div>
    );
};

export default Payment;